import { Link } from 'react-router-dom';

export default function AboutCta() {
  return (
    <section className="py-24 bg-[#FAF7FC]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Numbers */}
          <div className="grid grid-cols-2 gap-6">
            {[
              { value: '50M+', label: 'People affected by epilepsy globally', icon: 'ri-global-line' },
              { value: '80%', label: 'Live in low-income countries without care', icon: 'ri-map-pin-line' },
              { value: '75%', label: 'Treatment gap in sub-Saharan Africa', icon: 'ri-heart-pulse-line' },
              { value: '3x', label: 'Higher mortality risk without treatment', icon: 'ri-alert-line' },
            ].map((s) => (
              <div key={s.label} className="bg-white rounded-2xl p-6 border border-purple-100">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#7B2D8B]/10 mb-4">
                  <i className={`${s.icon} text-[#7B2D8B] text-lg`}></i>
                </div>
                <div className="text-3xl font-extrabold text-[#7B2D8B] mb-2">{s.value}</div>
                <div className="text-gray-500 text-xs leading-snug">{s.label}</div>
              </div>
            ))}
          </div>

          {/* Right: CTA */}
          <div>
            <span className="text-xs font-semibold uppercase tracking-[4px] text-[#7B2D8B] mb-4 block">The Urgency is Real</span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
              The Time to Act<br />
              is <span className="text-[#7B2D8B]">Now</span>
            </h2>
            <p className="text-gray-500 leading-relaxed mb-8">
              Every day without action means more avoidable deaths, more families torn apart by stigma, and more children denied an education because of a condition that is treatable. IKIRU is on the ground, doing the work — and we need your support to do more.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/get-involved"
                className="px-7 py-3.5 rounded-full bg-[#7B2D8B] text-white font-semibold text-sm hover:bg-[#6a2578] transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Support Our Mission
              </Link>
              <Link
                to="/programs"
                className="px-7 py-3.5 rounded-full border-2 border-[#7B2D8B] text-[#7B2D8B] font-semibold text-sm hover:bg-[#7B2D8B]/5 transition-colors cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
              >
                Explore Our Programs <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
